import { Routes } from '@angular/router';
import { InstructionsPageComponent } from './instructions-page.component';

export const INSTRUCTIONS_ROUTES: Routes = [
  {
    path: 'instructions',
    component: InstructionsPageComponent
  }
];
